module.exports = "﻿<div ui-view></div>\r\n";